// ボックスの初期表示
window.boxDisplay = function() {
  $('#boxes').html('');
  $('.p-reservation_form_submit_btn').addClass('back');
  $('.p-reservation_form_submit_btn').prop('disabled', true);
  let storeId = $('#reserve_store_id').val();
  let requestedAt = $('#reserve_requested_at').val();
  if (storeId == '' || requestedAt == '') {
    return false;
  }
  $.ajax({
    url: '/reservations/boxes',
    type: 'POST',
    data: {
      store_id: storeId,
      requested_at: requestedAt,
    },
    dataType: 'json'
  }).done(function(data) {
    $('#boxes').html(data.boxes);
    let emptyItem = false;
    $('.nested-fields').each(function() {
      let box = $(this);
      let itemId = box.find('.reserve_item_id').val();
      let courseType = box.find('.reserve_course_type').val();
      if (itemId == '' || courseType == '') {
        emptyItem = true;
        return true;
      }
      $.ajax({
        url: '/reservations/item_point',
        type: 'POST',
        data: { id: itemId },
        dataType: 'json'
      }).done(function(data) {
        let empty_boxes = $('#box_list' + courseType + ' > .empty');
        let empty_count = empty_boxes.length

        if (empty_count < data.point) {
          $('.p-reservation_form_field_item_error').remove();
          box.append('<p class="p-reservation_form_field_item_error">コースに空きがありません。</p>');
        } else {
          for (var i = 0; i < data.point; i++) {
            empty_boxes.eq(i).removeClass('empty');
            empty_boxes.eq(i).addClass('active');
          }
        }
      });
    });
    if(emptyItem == false) {
      $('.p-reservation_form_field_item_error').remove();
      $('.p-reservation_form_submit_btn').removeClass('back');
      $('.p-reservation_form_submit_btn').prop('disabled', false);
    }
  });
}

// ボックス初期表示
$(function() {
  setTimeout(function() {
    boxDisplay();
  }, 500);

  let name = sessionStorage.getItem('name');
  let tel = sessionStorage.getItem('tel');
  let introducedStore = sessionStorage.getItem('introducedStore');
  let storeId = sessionStorage.getItem('storeId');
  $('#reserve_name').val(name);
  $('#reserve_tel').val(tel);
  $('#reserve_introduced_store').val(introducedStore);
  $('#reserve_store_id').val(storeId);
  setTimeout(function() {
    calendarDisplay();
  }, 200);
});

$(window).ready(function() {
  let select_date = $('#reserve_requested_at').val()
  // 店舗の変更
  $('#reserve_store_id').on('change', function() {
    $('.input-date').each(function() {
      $(this).removeClass('holiday');
      $(this).find('.symbol').text('');
    });
    let storeId = $('#reserve_store_id').val()
    if (storeId == '') {
      $('#boxes').html('')
      $('.p-reservation_form_submit_btn').addClass('back')
      $('.p-reservation_form_submit_btn').prop('disabled', true)
      return false
    }
    calendarDisplay();
    boxDisplay();
  })

  // 現在の日付を取得
  function dateToStr24HPad0(date, format) {
    if (!format) {
      format = 'YYYY-MM-DD-hh-mm'
    }
    format = format.replace(/YYYY/g, date.getFullYear())
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
    return format
  }
  current_date = dateToStr24HPad0(new Date(), 'YYYY-MM-DD-hh-mm')
  current_date_2 = dateToStr24HPad0(new Date(), 'YYYY-MM-DD')

  // 希望日の変更
  $(document).on('change', '#reserve_requested_at', function () {
    select_date = $('#reserve_requested_at').val()

    if (select_date == '') {
      $('#boxes').html('')
      $('.p-reservation_form_submit_btn').addClass('back')
      $('.p-reservation_form_submit_btn').prop('disabled', true)
      return false
    }

    $('.reserve_course_type').each(function (i) {
      input_date = $(this).val()
      if (input_date == '1') {
        input_date = `${select_date}-09-00`
      } else if (input_date == '2') {
        input_date = `${select_date}-11-00`
      } else {
        input_date = `${select_date}-13-00`
      }
      if (current_date > input_date) {
        if (i == 1) {
          alert('当日のご予約は1時間前までとなります。')
        }
        $(this).val('')
      }
    })

    let date = new Date(select_date)
    //曜日を取得 0=日 6=土
    let week = date.getDay()
    if (current_date_2 > select_date) {
      alert('過去の日付です。選択しなおしてください。')
      $(this).val('')
      $('#reserve_introduced_store').focus()
    }
    else if (select_date == '2022-12-31' || select_date == '2023-01-01' || select_date == '2023-01-02' || select_date == '2023-01-03' || select_date == '2023-01-04') {
      alert('年末年始休暇となります。選択しなおしてください。')
      $('#reserve_introduced_store').focus()
      $(this).val('')
    }
    else if (week == 2) {
      alert('火曜日は定休日となります。選択しなおしてください。')
      $('#reserve_introduced_store').focus()
      $(this).val('')
    }
    boxDisplay()
  })

  // コースの変更
  $(document).on('change', '.reserve_course_type', function () {
    $(this).each(function () {
      input_date = $(this).val()
      if (input_date == '1') {
        input_date = `${select_date}-09-00`
      } else if (input_date == '2') {
        input_date = `${select_date}-11-00`
      } else {
        input_date = `${select_date}-13-00`
      }
      if (current_date > input_date) {
        alert('当日のご予約は1時間前までとなります。')
        $(this).val('')
      }
      boxDisplay()
    })
  })

  // 商品の変更
  $(document).on('change', '.reserve_item_id', function () {
    boxDisplay()
  })

  // バリデーション
  $('#form').submit(function () {
    $('.p-reservation_error').empty()

    let name = $('#reserve_name').val()
    let tel = $('#reserve_tel').val()
    let storeId = $('#reserve_store_id').val()
    let requestedAt = $('#reserve_requested_at').val()
    let count = 0
    if (name == '') {
      if (count == 0) {
        $('.p-reservation_error').append('<div class="p-reservation_error_content"></div>')
      }
      count = ++count
      $('.p-reservation_error_content').append('<p>お名前を入力してください</p>')
    }
    if (tel == '') {
      if (count == 0) {
        $('.p-reservation_error').append('<div class="p-reservation_error_content"></div>')
      }
      count = ++count
      $('.p-reservation_error_content').append('<p>電話番号を入力してください</p>')
    }
    if (storeId == '') {
      if (count == 0) {
        $('.p-reservation_error').append('<div class="p-reservation_error_content"></div>')
      }
      count = ++count
      $('.p-reservation_error_content').append('<p>ご利用店舗を入力してください</p>')
    }
    if (requestedAt == '') {
      if (count == 0) {
        $('.p-reservation_error').append('<div class="p-reservation_error_content"></div>')
      }
      count = ++count
      $('.p-reservation_error_content').append('<p>ご希望日を入力してください</p>')
    }
    if (count != 0) {
      $('.p-reservation_form_submit_btn').addClass('back')
      $('.p-reservation_form_submit_btn').prop('disabled', true)
      $('body, html').animate({ scrollTop: 0 }, 300, 'linear')
      return false
    }
  })

  // 持ち込みタイミングの切り替え
  $('input[name="reserve[carry_type]"]:radio').on('change', function () {
    let carryType = $(this).val()
    if (carryType == 1) {
      $('.carry_type_text').text('当日持込')
    } else {
      $('.carry_type_text').text('前日まで持込')
    }
  })

  // 商品追加ボタン押下
  $('#add-btn').on('click', function () {
    setTimeout(function () {
      let carryType = $('input[name="reserve[carry_type]"]:checked').val()
      if (carryType == 1) {
        $('.carry_type_text').text('当日持込')
      } else {
        $('.carry_type_text').text('前日まで持込')
      }
      $('.p-reservation_form_field_item_number').each(function (i, elem) {
        $(elem).text(i + 1)
      })
    }, 300)
  })

  // 商品削除ボタン
  $(document).on('click', '.remove_fields', function () {
    setTimeout(function () {
      $('.p-reservation_form_field_item_number').each(function (i, elem) {
        $(elem).text(i + 1)
      })
      boxDisplay()
    }, 300)
  })

  // サインモーダルオープン
  $('#open-calendar-modal').on('click', function(e) {
    e.preventDefault();
    $('#calendar-modal').addClass('active');
  });

  // モーダルクローズ
  $('.modal-close').on('click', function() {
    $('.c-modal').removeClass('active');
  });

  $('.c-modal').on('click', function(e) {
		if($(e.target).find('.c-modal_body_content').length) {
			$('.c-modal').removeClass('active');
		}
	});

  // カレンダー入力
  $('.input-date').on('click', function() {
    select_date = $(this).data('date');
    $('#reserve_requested_at').val(select_date);
    $('.c-modal').removeClass('active');

    if (select_date == '') {
      $('#boxes').html('')
      $('.p-reservation_form_submit_btn').addClass('back')
      $('.p-reservation_form_submit_btn').prop('disabled', true)
      return false
    }

    $('.reserve_course_type').each(function (i) {
      input_date = $(this).val()
      if (input_date == '1') {
        input_date = `${select_date}-09-00`
      } else if (input_date == '2') {
        input_date = `${select_date}-11-00`
      } else {
        input_date = `${select_date}-13-00`
      }
      if (current_date > input_date) {
        if (i == 1) {
          alert('当日のご予約は1時間前までとなります。')
        }
        $(this).val('')
      }
    })

    let date = new Date(select_date)
    //曜日を取得 0=日 6=土
    let week = date.getDay()
    if (current_date_2 > select_date) {
      alert('過去の日付です。選択しなおしてください。')
      $(this).val('')
      $('#reserve_introduced_store').focus()
    }
    else if (select_date == '2022-12-31' || select_date == '2023-01-01' || select_date == '2023-01-02' || select_date == '2023-01-03' || select_date == '2023-01-04') {
      alert('年末年始休暇となります。選択しなおしてください。')
      $('#reserve_introduced_store').focus()
      $(this).val('')
    }
    else if (week == 2) {
      alert('火曜日は定休日となります。選択しなおしてください。')
      $('#reserve_introduced_store').focus()
      $(this).val('')
    }
    boxDisplay()
  });

  // カレンダー初期表示
  let params = location.search;
  if(params.match(/\?start_date\=/)) {
    $('#calendar-modal').addClass('active');
  }

  // カレンダー表示
  window.calendarDisplay = function() {
    let storeId = $('#reserve_store_id').val();
    if (storeId == '') {
      return false;
    }
    let date_arry = [];
    $('.input-date').each(function() {
      let date = $(this).data('date');
      date_arry.push(date);
    });
    $.ajax({
      url: '/reservations/calendar_data',
      type: 'POST',
      dataType: 'json',
      data: { date_arry: date_arry, store_id: storeId }
    }).done(function(data) {
      $('.input-date').each(function() {
        let date = $(this).data('date');
        let arry = data.calendar_data[date];
        if(arry[0] == true) {
          $(this).addClass('holiday');
          return true;
        }
        if(arry[1] == 1) {
          $(this).find('.symbol').text('○');
        } else if(arry[1] == 2) {
          $(this).find('.symbol').text('△');
        } else if(arry[1] == 3) {
          $(this).find('.symbol').text('×');
        }
      });
    });
  }

  // セッションストレージ
  $('#reserve_name').on('change', function() {
    let name = $(this).val();
    sessionStorage.setItem('name', name);
  });

  $('#reserve_tel').on('change', function() {
    let tel = $(this).val();
    sessionStorage.setItem('tel', tel);
  });

  $('#reserve_introduced_store').on('change', function() {
    let introducedStore = $(this).val();
    sessionStorage.setItem('introducedStore', introducedStore);
  });

  $('#reserve_store_id').on('change', function() {
    let storeId = $(this).val();
    sessionStorage.setItem('storeId', storeId);
  });
});
